export default __webpack_public_path__ + "static/media/mr_mrs_smith_background_l2.c4b584ec.jpg";